import { Distributor } from "../_models/Distributor";

export class DistributorMapper {
    static serverToLocal(serverDistributor) {
        return Distributor(serverDistributor);
    }

    static allServerToLocal(serverDistributors = []) {
        return serverDistributors.map(this.serverToLocal);
    }
}